import React, { Component } from 'react';
import Video from '../../HomePage/Video';
import FooterPartner from '../../../FooterPartner/FooterPartner';
import {levels} from './AYHASponsorData';
import './AYHASponsor.scss';
import 'animate.css'

class AYHASponsor extends Component {
  render() {
    return (
      <section className="section d-flex flex-column align-items-center justify-content-center animate__animated animate__fadeInUp">
          <div id="enrichment" className="info d-flex flex-column align-items-center justify-content-center" data-testid="Enrichment">
            <h2>Become a Sponsor</h2>
          </div>
          <div className="enrichment__container">
            <div className='enrichment-video__container'>
              <Video url="https://www.youtube.com/watch?v=ebkY5y8esFw&t=17s"/>
            </div>
            <div className="enrichment-gl-data__container">
              <p className="text-justify">
              606 Academy uses sports to build stronger, healthier communities. We offer year-round programs for kids (K–12) and adults, including multi-sport training, leagues, after-school sessions, and fitness opportunities.Your support helps keep programs affordable and funds essentials like equipment, gym space, coaching, and scholarships. By sponsoring 606 Academy, you’re not just advertising your business — you’re investing in access, equity, and growth for families in your community.

              </p>
              <a className="btn-lg donate-btn-2" href="https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/37379/" role="button" target=" " >Donate</a>
            </div>
            <div className="gifts">
            <p>
              To show gratitude for helping kids in our community sponsors will recieve the following.
              </p>
              {levels && levels.length > 0 && levels.map((item) =>
                <div className="classes-col col-md-6">
                  <h5 className='ayha-header'>{item.name}</h5>
                  <ul className="classes list-group list-group-flush">
                    {item.description.map((activity) => 
                    <li className="list-group-item bg-transparent">{activity}</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <FooterPartner />
      </section>
    );
  }
}

export default AYHASponsor;